import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=31d2d076&"
import script from "./addressBook.vue?vue&type=script&lang=js&"
export * from "./addressBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports